export default __webpack_public_path__ + "static/media/gastro_2.14b9849d.jpg";